import { jsonGet, jsonPost } from "../api";

export const getKeywordMetrics = (brandId) =>
  jsonGet(`brands/${brandId}/keywords/metrics`);

export const enrichKeywords = (brandId, body = {}) =>
  jsonPost(`brands/${brandId}/keywords/enrich`, body);
